<template>
  <div class="draw_container">
      <div class="bg1"></div>
      <div class="bg2"></div>
  </div>
</template>

<script>
export default {
    data(){
        return{}
    },
    created(){
        document.getElementsByTagName('title')[0].innerText ="你画我猜游戏规则"
    }
}
</script>

<style lang="scss" scoped>
@import url('../../assets/css/base.css');
.draw_container{
    width:100vw;
    height: 100vh;
    .bg1{
        background: url('../../assets/images/nhwc/rules/yxgz1_icon@2x.png')no-repeat;
        background-size:cover;
        width:100vw;
        height: 32rem;
    } 
    .bg2{
        background: url('../../assets/images/nhwc/rules/yxgz2_icon@2x.png')no-repeat;
        background-size:cover;
        width:100vw;
        height:33rem;
    }

}
</style>


// WEBPACK FOOTER //
// src/components/draw/draw_rules.vue